import React, { useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";

function ComingSoonModal({ onClose }) {
  const backdropRef = useRef(null);
  const previouslyFocused = useRef(null);

  // Trap scroll and handle ESC close
  useEffect(() => {
    previouslyFocused.current = document.activeElement;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
      previouslyFocused.current && previouslyFocused.current.focus?.();
    };
  }, [onClose]);

  const handleBackdropMouseDown = useCallback(
    (e) => {
      if (e.target === backdropRef.current) onClose?.();
    },
    [onClose]
  );

  const view = (
    <div
      ref={backdropRef}
      onMouseDown={handleBackdropMouseDown}
      style={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="Coming soon"
    >
      <div style={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div style={styles.imageContainer}>
          <img src="/AniBot.png" alt="Coming Soon" style={styles.image} />
        </div>

        <h2 style={styles.title}>Backend Coming Soon</h2>
        <p style={styles.subtitle}>
          We’re working hard behind the scenes. Stay tuned for updates!
        </p>

        <button onClick={onClose} style={styles.closeButton} aria-label="Close">
          ×
        </button>
      </div>
    </div>
  );

  const portalTarget = document.getElementById("modal-root") || document.body;
  return ReactDOM.createPortal(view, portalTarget);
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: 20,
  },
  modal: {
    backgroundColor: "#1f1f1f",
    width: "90%",
    maxWidth: 420,
    padding: 32,
    borderRadius: 8,
    color: "#fff",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    minHeight: 400,
    justifyContent: "center",
  },
  imageContainer: {
    width: "100%",
    paddingBottom: "100%",
    position: "relative",
    marginBottom: 20,
  },
  image: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: 4,
  },
  title: {
    fontSize: 26,
    fontWeight: "bold",
    color: "#efac00",
    marginBottom: 18,
    marginTop: -4,
  },
  subtitle: {
    fontSize: 14,
    marginBottom: 18,
    color: "#ddd",
    marginTop: -2,
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
    fontSize: 24,
    color: "#fff",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
};

export default ComingSoonModal;